module.exports = __webpack_public_path__ + "img/reset-password-framme-store.7b262e4c.png";